import { Button, Form, Input } from 'antd';
import React, { useContext } from 'react'
import { LockOutlined, SendOutlined, UserOutlined } from '@ant-design/icons';
import { loginAdmin } from '../../Api/Auth';
import { ResponseContent } from '../../Models/ResponseContent';
import { User } from '../../Models/User';
import { PromiseSesionContext } from '../../Machines/ErrorMachine';
import jwt from 'jwt-decode' 

interface Props{
    rolComponent: "admin" | "client"
    onChange: (key: string) => void
}

const AuthLoginForm = ({rolComponent, onChange}:Props) => {
    const [loading, setLoading] = React.useState<boolean>(false);
    const {sesion, sendSesion} = useContext(PromiseSesionContext);
    const {error, sendError} = useContext(PromiseSesionContext);

    type FieldType = {
        usuario: string;
        password: string;
        remember?: string;
        email: string;
    };

    const onFinishFailed = (errorInfo: any) => {
    };

    const onFinish = async(values: FieldType) =>{
        try{
            setLoading(true)
            sendSesion("VERIFYYING");
            const result:ResponseContent = await loginAdmin(values.email, values.password)
            if(result){
                localStorage.setItem("token", result.access_token);
                const user:User = jwt(localStorage.getItem("token") || "")

                sendSesion({type: "AUTHORIZED", data:{user: user, rol: user?.role_id}});
                sendError({type: "ERROR", data:{message:"¡Bienvenido!", type:"success"}})

                setLoading(false)
            }

        }
        catch(error:any){
            sendSesion("UNAUTHORIZED");
            setLoading(false)
            if(error.code == 'ERR_NETWORK') {
                sendError({type: "ERROR", data:{message:"Problemas de conexion"}})
                return
            }
            sendError({type: "ERROR", data:{message:"Verifique los datos ingresados"}})
            return;
        }
    }
  return (
    <div className='authLoginForm-section'>
        <Form
        disabled={loading}
        name="basic"
        className=''
        layout={"vertical"}
        variant='filled'
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off">
            <Form.Item<FieldType>
            label={"Correo Electrónico"}
            name="email"
            className='formItem-AuthLoginForm'
            rules={[{ required: true, message: "El correo es requerido" }, {max:50, message:"Maximo 50 caracteres"}, {type:'email', message:"No es un correo valido"}]}
            >
            <Input placeholder={"tu@correo.com"} className='input-AuthLoginForm' />
            </Form.Item>

            <Form.Item<FieldType>
            label={"Contraseña"}
            name="password"
            className='formItem-AuthLoginForm'
            rules={[{ required: true, message: "La contraseña es requerida" }, ]}
            >
            <Input prefix={<LockOutlined />} type="password" className='input-AuthLoginForm'  />
            </Form.Item>


            <Form.Item style={{margin:"5px 0"}} >
            <Button className='button-AuthLoginForm'  type="primary" htmlType="submit">
                Ingresar <SendOutlined />
            </Button>
            </Form.Item>

            <Button style={{width:"100%"}}  type="link" onClick={()=>{onChange("3")}}>
                Recuperar cuenta
            </Button>
            </Form>  

            

    </div>
  )
}

export default AuthLoginForm

